import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { ThreeStepsDetails } from '@typings/ResidentTypes';
import useResidentDetailsFetch from '@hooks/useResidentDetailsFetch';
import { ErrorsProvider } from '@contexts/ErrorsContext';
import HavingConversationDropdown from './components/HavingConversationDropdown';
import Introduction from './components/Introduction';
import HavingConversationForm from './components/HavingConversationForm';
import ConversationLog from './components/ConversationLog';

enum StepChangeDirection {
  Previous = 'prev',
  Next = 'next',
}

interface StepFiveProps {
  role: string;
  slug: string | undefined;
  threeStepsData: ThreeStepsDetails;
  changeStep: (status: StepChangeDirection) => void;
  handleGetResidentDetails: () => Promise<void>;
}

export interface NextOfKinDetails {
  fullName: string;
  relationship: string;
  phoneNumber: string;
}

const StepFiveComponent: React.FC<StepFiveProps> = ({
  role,
  slug,
  threeStepsData,
  changeStep,
  handleGetResidentDetails,
}: StepFiveProps) => {
  const { residentDetails } = useResidentDetailsFetch(slug);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [nextOfKinDetails, setNextOfKinDetails] = useState<NextOfKinDetails>({
    fullName: '',
    relationship: '',
    phoneNumber: '',
  });

  useEffect(() => {
    handleGetResidentDetails();
  }, [handleGetResidentDetails]);

  const handleFormSubmit = () => {
    setFormSubmitted(!formSubmitted);
  };

  return (
    <div className="mt-5 md:mt-10">
      <h1 className="govuk-heading-xl">
        {residentDetails?.profile.full_name} - Conversations
      </h1>
      <Introduction />
      <HavingConversationDropdown />
      <HavingConversationForm
        role={role}
        slug={slug}
        residentDetails={residentDetails}
        nextOfKinDetails={nextOfKinDetails}
        setNextOfKinDetails={setNextOfKinDetails}
        onFormSubmit={handleFormSubmit}
      />
      <ConversationLog
        slug={slug}
        nextOfKinDetails={nextOfKinDetails}
        formSubmitted={formSubmitted}
      />

      <div className="govuk-button-group justify-between mt-10 govuk-bp:mt-14">
        <button
          type="submit"
          className="govuk-button govuk-button--secondary"
          onClick={() => changeStep(StepChangeDirection.Previous)}
        >
          Previous
        </button>

        <button
          type="submit"
          className="govuk-button"
          data-module="govuk-button"
          onClick={() => changeStep(StepChangeDirection.Next)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

const StepFive: React.FC<StepFiveProps> = props => {
  return (
    <ErrorsProvider>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <StepFiveComponent {...props} />
    </ErrorsProvider>
  );
};

export default StepFive;
